module.exports = __webpack_public_path__ + "assets/95dadaaedbf4f0f7bd90fbe0058fbfc8.png";